import { gql } from '@apollo/client';

// Supporting relationships where the caller's working org is the supportedOrganisation
// (i.e. the organisations that support us). Inverse of supportedCommunities.
export const GET_PARTNERSHIPS = gql`
query Partnerships {
  partnerships {
    id
    supporterOrganisationId
    supporterName
    scope
    scopeLabel
    description
    workforceTotal
    volunteerRoles {
      id
      title
      type
      icon
      interestedCount
      interested {
        id
        expressedAt
        person { id name }
      }
    }
    employmentCategories {
      id
      name
      shortName
      count
    }
    programs {
      card
      description
      stats {
        label
        value
      }
    }
  }
}`;
